import {createContext} from 'react';
import type {FloatingFocusManagerProps, FloatingPortalProps, UseInteractionsReturn} from '@floating-ui/react';

export type FloatingMenuContextType = {
    activeIndex?: null | number,
    /**
     * $FlowIgnoreMe WHY: Floating UI has no Flow type definitions
     **/
    getItemProps: UseInteractionsReturn['getItemProps'],
    level: number,
    /**
     * $FlowIgnoreMe WHY: Floating UI has no Flow type definitions
     **/
    portalProps?: FloatingPortalProps,
    /**
     * $FlowIgnoreMe WHY: Floating UI has no Flow type definitions
     **/
    floatingFocusManagerProps?: Partial<FloatingFocusManagerProps>,
};

const DEFAULT_CONTEXT = {
    getItemProps: () => ({}),
    level: 0,
};

export const FloatingMenuContext = createContext<FloatingMenuContextType>(
    DEFAULT_CONTEXT,
);

FloatingMenuContext.displayName = 'FloatingMenuContext';
